import { useXeroItemsApi } from 'apiProviders'
import { Autocomplete, AutocompleteProps } from './autocomplete'

export default function XeroItemAutocomplete(
    props: Omit<AutocompleteProps<string, false, true, false>, 'options' | 'getOptionLabel'>,
) {
    const itemsApi = useXeroItemsApi()
    const items = Array.isArray(itemsApi.data) ? itemsApi.data : []
    const itemIds: string[] = []
    for (const item of items) {
        if (item?.itemID && typeof item.itemID === 'string') {
            itemIds.push(item.itemID)
        }
    }

    return (
        <Autocomplete
            {...props}
            options={itemIds}
            getOptionLabel={id => {
                const item = items.find(x => x.itemID === id)
                return item ? `${item.code} - ${item.name}` : ''
            }}
        />
    )
}
